<template>
  <div class="salaries-content-block">
    <ArrowSvg :class="`salaries-content-block__arrow salaries-content-block__arrow--${groupId}`" />
    <ArrowSmallSvg :class="`salaries-content-block__arrow-small salaries-content-block__arrow--${groupId}`" />
    <div>
      <div class="salaries-content-block__description">
        <slot name="description" />
      </div>

      <div class="salaries-content-block__header">
        <slot name="header" />
      </div>

      <div class="salaries-content-block__description">
        <slot name="description2" />
      </div>

      <div class="salaries-content-block__header2">
        <slot name="header2" />
      </div>

      <div class="salaries-content-block__table">
        <slot name="table" />
      </div>
    </div>
  </div>
</template>

<script>
import ArrowSvg from './images/arrow.vue.svg';
import ArrowSmallSvg from './images/arrow-small.vue.svg';

export default {
  name: 'SalariesContentBlock',
  components: {
    ArrowSvg,
    ArrowSmallSvg,
  },
  props: {
    groupId: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.salaries-content-block {
  & + & {
    margin-top: 60px;

    @include mq('md') {
      margin-top: 120px;
    }
  }

  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 30px 80px rgba(35, 78, 100, 0.1), inset 1px 1px 0 rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(9px);
  padding: 45px 24px 31px;
  position: relative;
  will-change: transform;

  @include mq('md') {
    padding: 77px 88px 85px 86px;
  }

  &__arrow-small {
    position: absolute;
    left: 8px;
    top: 30px;

    @include mq('md') {
      display: none;
    }
  }

  &__arrow {
    display: none;
    position: absolute;
    left: 47px;
    top: 45px;

    @include mq('md') {
      display: block;
    }

    &--recap {
      color: #224373;
    }

    &--sdr-guide {
      color: #161a21;
    }

    &--ae-guide {
      color: #5d244d;
    }

    &--trends {
      color: #224373;
    }
  }

  @mixin removeBr {
    ::v-deep br {
      display: none;
    }

    ::v-deep br.keep {
      display: block;
    }

    @include mq('sm') {
      ::v-deep br {
        display: block;
      }
    }
  }

  &__header {
    font-weight: bold;
    font-size: 43px;
    line-height: 53px;
    letter-spacing: -1.45366px;

    @include removeBr;
  }

  &__description {
    font-size: 20px;
    line-height: 32px;
    letter-spacing: -0.3px;

    @include removeBr;
  }

  &__header2 {
    font-weight: 600;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: -0.75px;

    @include removeBr;
  }

  &__description2 {
    font-size: 17px;
    line-height: 32px;

    @include removeBr;
  }

  &__table {
    display: flex;
    margin-bottom: 16px;
  }
}
</style>
